import React, { useState } from 'react';
import { Card, CardContent } from './ui/Card';
import { Input } from './ui/Input';
import { Button } from './ui/Button';
import MatrixRain from './MatrixRain';
import { acceptInvite } from '../api';

const Shell = ({ children }) => (
  <div className="min-h-screen bg-surface flex items-center justify-center px-xl py-2xl relative overflow-hidden">
    <MatrixRain />
    <div className="relative z-10 w-full max-w-[380px] animate-scale-in">{children}</div>
  </div>
);

const AcceptInvite = ({ token }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setFieldErrors({});
    if (password !== confirm) {
      setFieldErrors({ confirm: 'Пароли не совпадают' });
      return;
    }
    if (password.length < 4) {
      setFieldErrors({ password: 'Минимум 4 символа' });
      return;
    }
    setLoading(true);
    try {
      await acceptInvite(token, password);
      setSuccess(true);
      setTimeout(() => { window.location.href = '/'; }, 3000);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Недействительная ссылка');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Shell>
        <Card className="shadow-lg">
          <CardContent className="p-2xl text-center space-y-lg">
            <div className="inline-flex items-center justify-center w-11 h-11 rounded-pill bg-success-soft text-success">
              <i className="bi bi-check-lg text-xl" aria-hidden="true" />
            </div>
            <div className="space-y-sm">
              <h1 className="text-section-title font-semibold text-text-strong">Пароль установлен</h1>
              <p className="text-body-sm text-text-muted">
                Сейчас вы будете перенаправлены на страницу входа…
              </p>
            </div>
            <Button
              variant="primary"
              className="w-full justify-center"
              icon="bi-box-arrow-in-right"
              onClick={() => { window.location.href = '/'; }}
            >
              Перейти ко входу
            </Button>
          </CardContent>
        </Card>
      </Shell>
    );
  }

  return (
    <Shell>
      <div className="text-center mb-2xl">
        <div className="inline-flex items-center justify-center w-11 h-11 rounded-lg bg-primary text-primary-fg shadow-md mb-lg">
          <i className="bi bi-person-plus text-xl" aria-hidden="true" />
        </div>
        <h1 className="text-page-title font-semibold text-text-strong">Приглашение</h1>
        <p className="eyebrow mt-sm">Придумайте пароль для входа</p>
      </div>

      <Card className="shadow-lg">
        <CardContent className="p-2xl">
          <form onSubmit={handleSubmit} className="space-y-xl">
            <Input
              label="Пароль"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={fieldErrors.password}
              hint="Минимум 4 символа"
              autoComplete="new-password"
              autoFocus
            />
            <Input
              label="Подтвердите пароль"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              error={fieldErrors.confirm}
              autoComplete="new-password"
            />

            {error && (
              <div
                role="alert"
                className="flex items-start gap-md p-lg rounded-md bg-destructive-soft border border-destructive/30 animate-fade-in"
              >
                <i className="bi bi-exclamation-triangle text-destructive" aria-hidden="true" />
                <p className="text-body-sm text-destructive">{error}</p>
              </div>
            )}

            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-full justify-center"
              loading={loading}
              disabled={!password || !confirm}
            >
              {loading ? 'Установка…' : 'Установить пароль'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Shell>
  );
};

export default AcceptInvite;
